import { render, staticRenderFns } from "./seeGoodsInfo.vue?vue&type=template&id=670a283c&scoped=true&"
import script from "./seeGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./seeGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./seeGoodsInfo.vue?vue&type=style&index=0&id=670a283c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a283c",
  null
  
)

export default component.exports